import {FormField} from "../form-field/form-field";

export class FormFieldRadio extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.$radio = null;
    }

    getVal(){
        const values = [];
        this.$radio.filter(":checked").each(
            (index,item)=>{
                values.push($(item).val());
            }
        );
        return values;
    }

    setVal(val,noEvent){
        this.$radio.find("[value='"+val+"']").attr("checked","checked");
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    ready(){
        super.ready();
        this.$radio = this.findMember("radio");
        this.$radio.click(
            (ev) => {
                this.$root.trigger("formField:changeVal");
            }
        );
    }
}

